import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faSync, faInbox, faPlus } from '@fortawesome/free-solid-svg-icons';

const EmptyStateMessage = ({ 
  message, 
  icon, 
  onRefresh, 
  actionText, 
  onAction, 
  actionIcon 
}) => (
  <div className="text-center py-5">
    <FontAwesomeIcon icon={icon || faInbox} size="4x" className="text-muted mb-3" />
    <h4>{message || 'Tidak ada data'}</h4>
    
    <div className="mt-4">
      {onRefresh && (
        <Button variant="outline-secondary" className="me-2" onClick={onRefresh}>
          <FontAwesomeIcon icon={faSync} className="me-1" /> Refresh Data
        </Button>
      )}
      
      {onAction && (
        <Button variant="primary" onClick={onAction}>
          <FontAwesomeIcon icon={actionIcon || faPlus} className="me-1" /> {actionText || 'Tambah Data'}
        </Button>
      )}
    </div>
  </div>
);

export default EmptyStateMessage;